import { useState } from "react";
import { notification, FormInstance } from "antd";
import {
  getAutoComplete,
  getPlaceDetails,
} from "../services/RegistrationService";

type AutoCompleteOption = {
  value: string;
  label: string;
};

interface Address {
  address1: string;
  city: string;
  state: string;
  zipcode: string;
}

export const useCreditCardForm = (form: FormInstance) => {
  const [autoCompleteOptions, setAutoCompleteOptions] = useState<
    AutoCompleteOption[]
  >([]);
  const [manualAddressEntry, setManualAddressEntry] = useState<boolean>(false);
  const [billingAddress, setBillingAddress] = useState<Address>({
    address1: "",
    city: "",
    state: "",
    zipcode: "",
  });

  let timer: NodeJS.Timeout;

  const handleAddressSearch = async (searchText: string) => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(async () => {
      if (searchText.length >= 3) {
        try {
          const data = await getAutoComplete(searchText);
          if (data && Array.isArray(data.predictions)) {
            const descriptions = data.predictions.map(
              (item: { description: string; place_id: string }) => ({
                value: item.description,
                id: item.place_id,
              })
            );
            setAutoCompleteOptions(descriptions);
          }
        } catch (error) {
          notification.error({
            message: "Error",
            description: "Failed to get auto complete address.",
          });
        }
      } else {
        setAutoCompleteOptions([]);
      }
    }, 800);
  };

  const handleAddressSelect = async (value: any, option: any) => {
    try {
      const apiResponse = await getPlaceDetails(option.id, option.value);
      const {
        city,
        state,
        zip: zipcode,
        streetName: address1,
      } = apiResponse.results[0];
      setBillingAddress({ address1, city, state, zipcode });
      form.setFieldsValue({
        address1: address1,
        city: city,
        state: state,
        zipcode: zipcode,
      });
      setAutoCompleteOptions([]);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddressReset = () => {
    form.setFieldsValue({
      billingAddress: "",
      address1: "",
      city: "",
      state: "",
      zipcode: "",
    });
    setBillingAddress({
      address1: "",
      city: "",
      state: "",
      zipcode: "",
    });
    setManualAddressEntry(false);
  };

  const handleCantFindAddress = () => setManualAddressEntry(true);

  const handleInputNameChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    let value = e.target.value;
    value = value.trimStart();
    form.setFieldsValue({ [key]: value });
  };

  return {
    autoCompleteOptions,
    manualAddressEntry,
    billingAddress,
    handleAddressSearch,
    handleAddressSelect,
    handleAddressReset,
    handleCantFindAddress,
    handleInputNameChange,
  };
};
